import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class ClientIncidentsService {

  private URI = environment.URL_API;

  constructor(
    private http: HttpClient
  ) { }

  async createIncident(payload: any) {

    return await this.http
      .post<any>(
        `${this.URI}/clients-incidents`,
        payload
      )
      .toPromise();
  }

  async getIncidentsByClient(
    clientId: string
  ) {

    return await this.http
      .get<any>(
        `${this.URI}/clients-incidents/client/${clientId}`
      )
      .toPromise();
  }

  async updateIncident(
    incidentId: string,
    payload: any
  ) {

    return await this.http
      .put<any>(
        `${this.URI}/clients-incidents/${incidentId}`,
        payload
      )
      .toPromise();
  }

  async deleteIncident(
    incidentId: string
  ) {

    return await this.http
      .delete<any>(
        `${this.URI}/clients-incidents/${incidentId}`
      )
      .toPromise();
  }
}